import { makeStyles, Theme } from "@material-ui/core/styles";
import { CardPlan } from "./index";

const paddingCard = 20;
const borderRadius = 14;

type DynamicStylesProps = Pick<CardPlan, "photo">;

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
    width: "100%",
    marginBottom: 20,
  },

  planInfos: {
    width: 500,
    padding: paddingCard,
    borderRadius,
    backgroundColor: theme.palette.background.paper,
  },

  planTop: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  planOwner: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: 258,
  },

  collunName: {
    display: "flex",
    flexDirection: "column",
  },

  ownerPhoto: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 42,
    height: 42,
    borderRadius,
    backgroundColor: theme.palette.secondary.main,
  },

  picture: {
    width: "100%",
    height: "100%",
    borderRadius,
    backgroundImage: ({ photo }: DynamicStylesProps) =>
      photo ? `url(${photo})` : "none",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundClip: "border-box",
  },

  profileIcon: {
    height: 20,
  },

  ownerName: {
    fontSize: 16,
    fontWeight: "bold",
    marginLeft: 16,
    width: 175,
  },

  planActions: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: 110,
  },

  "@media (max-width: 1024px)": {
    ownerName: {
      width: 150,
    },

    planOwner: {
      width: "60%",
    },

    planInfos: {
      width: "85%",
    },

  },
}));

export default useStyles;
